<script>
export default {
  props: {
    recipient: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      defaultPicture: require('@assets/images/motto-mortgage-social-white-blue.jpg'),
    }
  },
  computed: {
    getTradename() {
      return `Motto Mortgage ${this.recipient.primaryOffice?.tradeName || ''}`
    },
    getAddress() {
      const { city, state, zipCode } =
        this.recipient.recipientType === 'office' ? this.recipient : this.recipient.primaryOffice || {}

      if (city && state && zipCode) {
        return `${city}, ${state} - ${zipCode} `
      }

      return ''
    },
  },
  methods: {
    async selectRecipient({ recipientId }) {
      if (this.disabled) {
        return
      }

      this.$emit('select-recipient', { recipientId })
    },
  },
}
</script>

<template>
  <div
    :class="{ [$style.recipientSearchResultContainer]: true, [$style.selected]: selected, [$style.disabled]: disabled }"
    @click="selectRecipient({ recipientId: recipient.id })">
    <div>
      <template v-if="recipient.recipientType === 'user'">
        <div :class="$style.userInfoContainer">
          <img v-if="recipient.photoUrl" :class="$style.userPhoto" :src="recipient.photoUrl" alt="" />
          <img v-else :class="$style.userPhoto" :src="defaultPicture" alt="" />
          <div :class="$style.userInfo">
            <h4 class="color-primary-blue font-weight-bold">{{ recipient.name }}</h4>
            <p class="p1 color-primary-blue">{{ getTradename }}</p>
            <p class="p1 color-primary-blue">{{ getAddress }}</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div :class="$style.officeInfoContainer">
          <div :class="$style.officeInfo">
            <h4 class="color-primary-blue font-weight-bold">Motto Mortgage {{ recipient.tradeName }}</h4>
            <p class="p1 color-primary-blue">{{ recipient.primaryOwnerName }}</p>
            <p class="p1 color-primary-blue">
              {{ getAddress }}
            </p>
          </div>
        </div>
      </template>
    </div>
    <slot name="actionButton"></slot>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.recipientSearchResultContainer {
  @media (max-width: $lg-breakpoint) {
    flex-wrap: wrap;
    padding-right: 5px;
  }

  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
  background: $white;
  border: 1px solid $light-gray;
  border-radius: 16px;

  &:hover {
    background: $lightest-gray;
  }
}

.recipientSearchResultContainer.disabled {
  cursor: default;
  background: $lightest-gray;
}

.selected {
  background: $lightest-gray;
  border: 1px solid $primary-blue;
}

.userInfoContainer {
  @media (max-width: $lg-breakpoint) {
    padding-top: 10px;
    margin-bottom: 5px;
  }

  display: flex;
  align-items: center;

  img {
    flex-shrink: 0;
    margin: 5px;
  }
}

.userInfo {
  margin-left: 20px;

  h4 {
    margin-bottom: 0;
  }
}

.officeInfoContainer {
  padding: 10px 20px;

  h4 {
    margin-bottom: 0;
  }
}

.userPhoto {
  @media (max-width: $lg-breakpoint) {
    margin-left: 20px;
  }

  width: 70px;
  height: 70px;
  border-radius: 20px;
}
</style>
